import DoubleSelect from '../DoubleSelect';

const DoubleMultiSelect = ({ ...otherProps }) => (
  <DoubleSelect childMultiple {...otherProps} />
);

export default DoubleMultiSelect;
